import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Preloading } from '../../../../components/UI/Preloader/action';
import { publishFinalReport } from '../../../../Analyst/Cases/View/action'
import PdfView from '../../SurveyView/index';
import { closeCase } from '../../../../Analyst/Cases/View/action';
class CasesSectionModal extends Component {
    constructor() {
        super()
        this.state = {
            uploadModal: false,
            uploadModalError: false,
            uploadModalErrorMessage: '',
            previewReportModal: false,
            pdfUrl: null,
            showCloseCaseConfirmation: false,
            closeCaseBody: null,
        }
    }
    componentDidUpdate(prevProps) {
        if(this.props.closeCaseData !== prevProps.closeCaseData) {
            if(this.props.closeCaseSuccess === true){
                //this.props.closeCase(this.props.caseData.data.caseId);
                this.props.publishFinalReport(this.props.caseData.data.id)
            }
        }
        if (this.props.uploadModalError !== prevProps.uploadModalError) {
            if (this.props.uploadModalError) {
                this.setState({
                    uploadModalError: !this.state.uploadModalError,
                    uploadModalErrorMessage: (this.props.uploadModalError.response && this.props.uploadModalError.response.data) ? this.props.uploadModalError.response.data.message : "Something went wrong! Please try again."
                })
            }
            this.props.preloading(false);
        }
        if (this.props.previewReportdata !== prevProps.previewReportdata) {
            this.previewReport();
            this.setState({
                pdfUrl: this.props.previewReportdata
            }, () => {
            })
            this.props.preloading(false);
        }
        if (this.props.previewReportFail !== prevProps.previewReportFail) {
            if (this.props.previewReportFail.response.status === 400 ||
                this.props.previewReportFail.response.status === 500) {
                this.setState({
                    uploadModalError: !this.state.uploadModalError,
                    uploadModalErrorMessage: this.props.previewReportFail.response.data.message
                });
            }
            this.props.preloading(false);
        }
    }
    toggle = () => {
        this.setState({ uploadModal: !this.state.uploadModal })
    }
    errorclose = () => {
        this.setState({ uploadModalError: !this.state.uploadModalError })
    }
    previewReport = () => {
        this.setState((prevState) => ({ previewReportModal: !prevState.previewReportModal }))
    }
    handlePublishReport = () => {
        this.props.preloading(true);
        
        this.previewReport()
    }
   handleCloseCase = () => {
       this.setState({
           closeCaseBody: (
               <div>
                   <h5>Are you sure, you want to close the case?</h5>
                   <button
                       className="btn btn-primary mt-5" onClick={this.handleConfirmCloseCase}
                   >
                       Yes
                   </button>
                   <button
                       className="btn btn-danger mt-5 ml-3"
                       onClick={this.toggleCloseCaseConfirmation}
                   >
                       No
                   </button>
               </div>
           ),
       }, () => {
           this.toggleCloseCaseConfirmation();
       });
   };

   toggleCloseCaseConfirmation = () => {
       this.setState(prevState => ({
           showCloseCaseConfirmation: !prevState.showCloseCaseConfirmation,
       }));
   };

   handleConfirmCloseCase = () => {
       this.props.preloading(true);
       this.props.closeCase(this.props.caseData.data.caseId);
       this.toggleCloseCaseConfirmation();
       this.previewReport();
   };
    render() {
        return (
            <div>
                <Modal isOpen={this.state.uploadModal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Success</ModalHeader>
                    <ModalBody>
                        Section Successfully Uploaded
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.uploadModalError} toggle={this.errorclose} className={this.props.className}>
                    <ModalHeader toggle={this.errorclose}>Error</ModalHeader>
                    <ModalBody>
                        {this.state.uploadModalErrorMessage}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.errorclose}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.previewReportModal} toggle={this.previewReport} className="modal-lg">
                    <ModalHeader toggle={this.previewReport}>Preview Report</ModalHeader>
                    <ModalBody>
                        {/* {this.state.uploadModalErrorMessage} */}
                        <PdfView pdfUrl={this.state.pdfUrl} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color='info' title='Close Case' onClick={this.handleCloseCase}>Close Case</Button>
                       {/*  <Button color="primary" title="Publish" onClick={this.handlePublishReport}>
                            <i className="fa fa-send" aria-hidden="true"></i> &nbsp;Publish Report
                        </Button> */}
                        <Button color="secondary" onClick={this.previewReport}>Cancel</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.showCloseCaseConfirmation}>
                    <ModalBody>
                        {this.state.closeCaseBody}
                    </ModalBody>
                </Modal>

            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    uploadModal: state.section.uploadModal,
    uploadModalError: state.section.uploadModalFail,
    previewReportdata: state.section.previewReportSuccess,
    previewReportFail: state.section.previewReportFailure,
    caseData: state.section.caseDetails,
    closeCaseSuccess: state.section.closeCaseSuccess,
    closeCaseData: state.section.closeCaseData,
    publishedReport: state.section.publishedReport,
    publishReportSuccess: state.section.publishReportSuccess
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    publishFinalReport: (id) => { dispatch(publishFinalReport(id)) },
    closeCase: (id) => { dispatch(closeCase(id)) },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CasesSectionModal);
// export default CasesSectionModal
